import { AI_CHATBOT_ACTIONS, type AllChatbotActions } from "./actions/actions";
import { messagesReducer } from "./modules/chatbot-messages.reducer";
import { subscribtionReducer } from "./modules/chatbot-subscription.reducer";
import { flagsReducer } from "./modules/flags-reducer.reducer";
import type { ChatbotState } from "./types/chatbot.reducer.type";

export const chatbotInitialState: ChatbotState = {
  messages: [],
  isSending: false,
  showEmptyState: false,
  scrollToBottom: false,
  showScrollToBottom: false,
  isCreatingNewSession: false,
  canCloneFromPreviousChat: false,
  showRetryButton: true, // TODO: BD-4440 shouldn't this initially be false?
  retryButtonText: "Riprova", // TODO: BD-4440 shouldn't this initially be undefined?
};

function baseReducer(action: AllChatbotActions) {
  switch (action.type) {
    case AI_CHATBOT_ACTIONS.RESET:
      return {
        ...chatbotInitialState,
      };

    default:
      return {};
  }
}

export function chatbotReducer(state: ChatbotState, action: AllChatbotActions): ChatbotState {
  const messagesState = messagesReducer(state, action);
  const subscriptionState = subscribtionReducer(state, action);
  const flagsState = flagsReducer(state, action);

  const baseState = baseReducer(action);

  const combinedState = {
    ...state,
    ...messagesState,
    ...subscriptionState,
    ...flagsState,
    ...baseState,
  };

  return combinedState;
}
